import { create } from "zustand"
import { persist } from "zustand/middleware"
import createAvisoPedidoStore, { AvisoPedidoStore } from "./AvisoPedidoStore"
import createConfigsStore, { ConfigsStoreType } from "./ConfigsStore"
import createImpressaoStore, { ImpressaoStoreType } from "./ImpressaoStore.ts"
import createPedidosStore, { PedidosStoreType } from "./PedidosStore"
import createTabStatusStore, { TabStatusStoreType } from "./TabStatusStore.ts"

export type StoreType = PedidosStoreType &
    ConfigsStoreType &
    ImpressaoStoreType &
    AvisoPedidoStore &
    TabStatusStoreType

const useAppStore = create<StoreType>()(
    persist(
        (...opts) => ({
            ...createPedidosStore(...opts),
            ...createImpressaoStore(...opts),
            ...createConfigsStore(...opts),
            ...createAvisoPedidoStore(...opts),
            ...createTabStatusStore(...opts),
        }),
        {
            name: "app-store",
            partialize: state => ({
                configuracoes: state.configuracoes,
                tabStatus: state.tabStatus,
            }),
        }
    )
)

// Sincroniza o estado persistido (configuracoes + tabStatus) entre as ABAS do mesmo
// navegador. Cada aba mantém sua própria cópia EM MEMÓRIA do store, hidratada uma vez no
// load; sem isto, mudar o TIPO DE OPERAÇÃO (Automática/Manual/Visualização/Garçom), o
// aceite automático ou qualquer config numa aba só valia naquela aba até as outras
// recarregarem. O evento `storage` dispara apenas nas OUTRAS abas quando o localStorage
// muda (nunca na aba que gravou), então re-hidratar aqui reflete a mudança na hora, sem
// laço e sem reload.
if (typeof window !== "undefined") {
    window.addEventListener("storage", event => {
        if (event.key === "app-store") {
            useAppStore.persist.rehydrate()
        }
    })
}

export default useAppStore
